(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moving-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('moving-announcement')) {
    customElements.define(
      'moving-announcement',
      class MovingAnnouncement extends HTMLElement {
        connectedCallback() {
          if (this.dataset.initialized === 'true') return;
          this.dataset.initialized = 'true';

          const closeButton = this.querySelector(
            '[data-moving-announcement-close]'
          );

          if (!closeButton) return;

          const storageKey = this.dataset.storageKey;
          const isDesignMode = Boolean(
            window.Shopify && window.Shopify.designMode
          );

          if (!isDesignMode && storageKey) {
            try {
              if (
                window.sessionStorage.getItem(storageKey) ===
                'closed'
              ) {
                this.hidden = true;
                return;
              }
            } catch (error) {
              // The bar still works when storage is unavailable.
            }
          }

          closeButton.addEventListener('click', () => {
            this.hidden = true;

            if (!isDesignMode && storageKey) {
              try {
                window.sessionStorage.setItem(
                  storageKey,
                  'closed'
                );
              } catch (error) {
                // Closing does not depend on browser storage.
              }
            }

            window.dispatchEvent(new Event('resize'));
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
